import { render, staticRenderFns } from "./TablesStatsGraphsCard.vue?vue&type=template&id=28364884&scoped=true&"
import script from "./TablesStatsGraphsCard.vue?vue&type=script&lang=js&"
export * from "./TablesStatsGraphsCard.vue?vue&type=script&lang=js&"
import style0 from "./TablesStatsGraphsCard.vue?vue&type=style&index=0&id=28364884&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28364884",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAlert,VCard,VCardText,VCardTitle,VCol,VRow})
